import { render, staticRenderFns } from "./HeaderStatic.vue?vue&type=template&id=5fa3de87&scoped=true&"
import script from "./HeaderStatic.vue?vue&type=script&lang=js&"
export * from "./HeaderStatic.vue?vue&type=script&lang=js&"
import style0 from "./HeaderStatic.vue?vue&type=style&index=0&id=5fa3de87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa3de87",
  null
  
)

export default component.exports